// src/comps/projeventlist.jsx
import React from "react";
import { Link } from "react-router-dom";
import { Navbar } from "../App";
import placeholderImage from "../assets/homepage.jpg"; // Placeholder until actual images are added
import mahmudHasanImage from "../assets/mahmud_hasan.jpg";
import sudiptoMondolImage from "../assets/sudipto_mondol.jpg";
import tarikImage from "../assets/tarik.jpg";
import shahriarImage from "../assets/shahriar.jpg";

const REPORTS_URL = "https://docs.google.com/document/d/1BsBJLnQrNFEwfBB1Ygm8EJpuqpGej3N-/edit?rtpof=true";
const GALLERY_URL = "https://drive.google.com/drive/folders/1gN7kY_FChqDOWgzHxVJV9N7XJV2Wq6Qm?usp=sharing";

// Project data organized by category
const projectsData = {
  education: [
    {
      year: "2025",
      title: "Mahmud Hasan - A Success Story",
      description: "I am Mahmud Hasan, a recipient of a scholarship from the BUET'88 Welfare Foundation, Dhaka. I have completed my B.Pharm (Honours) in Pharmacy from Islamic University, Kushtia, in 2025. But this journey was not easy; it was filled with struggles, sacrifices, and relentless efforts. In 2017, a difficult time struck my life. My father suffered a stroke and became paralyzed. There were no earning members in our family. My father still has no ability to walk, my mother was mentally devastated, and my younger brother was still very young. I was completely lost—how I would manage this situation! How would I continue my studies and support my family! At that critical moment, a guiding light appeared in my life—Nazmul Huda Sharif Uddin Sir. He acted as a guardian who stood beside me. With his help, I received a scholarship from BUET'88 Welfare Foundation, Dhaka. This financial support was not just for my education but also a blessing for my family. With this assistance, I continued my studies and provided whatever help I could to my family. This chapter of my life taught me that in difficult times, giving up is not an option, fighting through hardships is the true meaning of survival. My mother, father, younger brother, and I stood strong for each other. And people like Nazmul Huda Sharif Uddin Sir made me believe that there are still kind-hearted individuals in this world who silently bring light into the lives of others. Now as I complete my studies, I am determined to use my knowledge and skills to contribute to society. My goal is to work in the pharmaceutical field and help improve healthcare in underserved communities. Today wherever I stand, it is not just because of my hard work but also because of those who stood by my side. I will always carry this gratitude with me, and in the future, I aspire to help others just as I once received help.",
      imagePath: mahmudHasanImage,
      imageOrientation: "portrait",
      isEnded: true
    },
    {
      year: "2024-present",
      title: "College Preparation Scholarship Program",
      description: "This project is primarily founded and conducted by Manush Manusher Jonno Foundation (MMF) to help support students' college admissions readiness through emphasizing their academic skills and leadership training. MMF is a US-based nonprofit organization committed to supporting underprivileged students in their pursuit of higher education. In 2024, Spreeha BUET'88 Foundation joined MMF to support 10 underprivileged high school graduates to achieve this goal. We are proud to announce that out of the 10 sponsored students, eight of them have been admitted to renowned universities across Bangladesh, including Dhaka University (DU) and Khulna University of Engineering & Technology (KUET). This success highlights the effectiveness of the program and its impact on students' futures. Motivated by these positive outcomes, our Global Executive Committee of the Foundation has decided to continue and expand this initiative, with the goal of reaching even more deserving students in the years to come.",
      imagePath: null,
      imageOrientation: "landscape",
      isEnded: false
    },
    {
      year: "2024-present",
      title: "Sudipto Mondol Story",
      description: "Sudipto Mondol, son of Susanto Kumar Mondol and Bharati Mondol, comes from Sukhdara village, Batiaghata, Khulna. In 2023, his father lost his job, which brought unforeseen hardship to the family. Despite these challenges, Sudipto started to search every avenue to receive financial help for his endeavor. The estimated amount to cover his educational and living expenses was BDT 10,000/- per month. In 2024, Spreeha BUET'88 Foundation decided to help Sudipto in continuing his higher education for the duration of his studies. Sudipto began his higher education journey at Jessore Medical College in 2024 with dreams of building a better future. This is another success story where our Foundation is providing consistent support so that bright students like Sudipto can focus on their studies and nurture their potential, rather than being burdened by uncertainty.",
      imagePath: sudiptoMondolImage,
      imageOrientation: "landscape",
      isEnded: false
    },
    {
      year: "2019-present",
      title: "Supporting Ariful's Education",
      description: "Nur Alam, originally from Noakhali, manages a low paid hardware store at Narayangonj. His income from the store was not sufficient to bear the educational expenses for his two school-going children. When his son, Ariful, got admission to Sylhet Cadet College in 2019, it became nearly impossible for him to continue to pay for his son's tuition. BUET'88 Welfare Foundation came to rescue since then. The foundation is providing BDT 2,000 per month for Ariful's education. Ariful passed HSC with a GPA 5.0 in 2025.",
      imagePath: null,
      imageOrientation: "landscape",
      isEnded: false
    }
  ],
  healthcare: [
    {
      year: "2020-2021",
      title: "Fundraising for Tarik",
      description: "In 2017, our friend Tarik (Md. Tarikul Islam Chowdhury), a BUET graduate of Batch 88, went to Mount Elizabeth Hospital, Singapore for a brief checkup with seemingly minor heart issues and chronic gastritis. That intended brief checkup became an odyssey of hospital visits both in Singapore and Chennai with tens of medical procedures only to find out that his heart cannot pump blood adequately due to unusually thick cardiac muscles with no conclusive diagnosis. His doctors, however, were suspecting cardiac amyloidosis, a rare heart disease that is caused by a deposit of amyloid, an abnormal protein in the heart tissue. This disease drastically reduces patient's life expectancy. Unfortunately, there is no specific treatment to take the amyloid out of the heart, however, there are preventive medical practices which either stop the abnormal protein from being produced or stabilize the protein so that it doesn't deposit within the heart. For a definitive diagnosis, Tarik needed to get a cardiac biopsy at a specialized hospital soon. If diagnosed, the treatment of cardiac amyloidosis needed to start immediately. The treatment is formidably expensive. Over the last few years, Tarik exhausted his savings on pre-diagnosis trials. To make matters worse, he went into medical retirement from Alfa Laval due to his health. All this has taken a toll on his mental and physical health. In October 2020, Spreeha BUET'88 Foundation took a fundraising initiative to help support Tarik's treatment at National University Hospital (NUH), Singapore. With the help and support from all of our friends, we not only shared his expenses for NUHC (National University Heart Center) procedures but also provided him with three months' supply of Tafamidis, a FDA approved preventive medicine by Pfizer which is proven to reduce the production of abnormal protein in the body or stabilize the protein so that it doesn't deposit within the heart. Tarik's heart condition was already critical at the time when he was diagnosed. On December 10, 2021, Tarik passed away from heart failure.",
      imagePath: tarikImage,
      imageOrientation: "portrait",
      isEnded: true
    },
    {
      year: "2021",
      title: "Fundraising for Shahriar",
      description: "Our friend Shahriar, a BUET graduate of Batch 88 (Naval Architecture), was diagnosed with Carcinoma Caecum and Hepatic Metastasis (stage four). Basically, he had colon cancer which eventually spread further to his liver. His doctors strongly suggested him to immediately start the appropriate treatment protocol which involves surgery to remove metastasis in bowel followed by liver resection and chemotherapy. This type of surgeries could be done overseas in specialized hospitals such as Mount Elizabeth Hospital (MEH) in Singapore. A preliminary estimate shows Shahriar needed approximately $250K - $300K to meet up his treatment expenses. Although Shahriar was capable to afford initial treatment expenses, the above estimated amount was impossible for him to bear alone. In April of 2021, Spreeha BUET'88 Foundation took a fundraising initiative to help support Shahriar's treatment at Mount Elizabeth Hospital (MEH), Singapore. With the help and support from all of our friends, we were able to share some of his expenses for MEH procedures. Sadly, Shahriar passed away in 2022.",
      imagePath: shahriarImage,
      imageOrientation: "square",
      isEnded: true
    },
    {
      year: "2022-present",
      title: "Supporting Bidhan",
      description: "Our friend Bidhan Roy has been suffering from neurological disease for a prolonged period. His disease caused severe physical weakness and affected his voice to the extent to comprehend. As a result, he is not physically capable of doing any job. He has been going through severe financial hardship since 2019. From our batch, we extended our help to bring him from his local town to Dhaka and provided the treatment via reputed physician. Since 2022, Spreeha BUET'88 Foundation has been providing Bidhan's medical cost in an amount of BDT 10,000/- per month. Besides, our batch mates from Chemical Engineering provided support to reconstruct his home, approximately BDT 2,00,000/- in January 2025.",
      imagePath: null,
      imageOrientation: "landscape",
      isEnded: false
    },
    {
      year: "2025",
      title: "Supporting Khaleque",
      description: "Our friend Khaleque's mother was diagnosed with cancer. He requested monetary support from Batch 88 for his mother's treatment. In March 2025, BUET'88 Welfare Foundation raised BDT 1,50,000/- for his mother. Later Khaleque informed us that the amount was enough, and no more money was needed.",
      imagePath: null,
      imageOrientation: "landscape",
      isEnded: true
    }
  ],
  others: [
    {
      year: "2024",
      title: "Supporting Hanif",
      description: "Our friend Hanif was unemployed for some time and had been going through a difficult period. In 2024, he became unable to pay for his children's education. To support Hanif and his children, BUET'88 Welfare Foundation donated him BDT 3,00,000 in September 2024.",
      imagePath: null,
      imageOrientation: "landscape",
      isEnded: true
    },
    {
      year: "2012-present",
      title: "Supporting Kamrul's Family",
      description: "Our friend Kamrul died in an accident, leaving two young kids and his wife. Although Kamrul's wife was a primary school teacher, it was financially difficult to raise the children all by herself. Since 2012, BUET'88 Welfare Foundation started providing monthly financial support for Kamrul's family, to make their journey a little easier. Till today, our foundation continues to provide BDT 4,000 per month to Kamrul's family. Currently, Kamrul's elder daughter is pursuing her studies at Mawlana Bhasani University Tangail, and his younger son is admitted at BUET in 2025.",
      imagePath: null,
      imageOrientation: "landscape",
      isEnded: false
    }
  ]
};

export default function ProjEventList() {
  return (
    <div className="bg-white min-h-screen w-screen">
      <Navbar />
      <div className="container mx-auto px-4 py-12">
        {/* Page Header */}
        <div className="text-center mb-12">
          <h1 className="text-black text-5xl font-bold mb-4">Our Projects</h1>
          <p className="text-black text-lg max-w-3xl mx-auto">
            Supporting education, healthcare, and community welfare through dedicated initiatives.
          </p>
          <div className="flex justify-center gap-4 mt-6">
            <a
              href={REPORTS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="border-2 border-[#800000] text-[#800000] py-2 px-6 rounded-full font-bold hover:bg-[#800000] hover:text-white transition"
            >
              REPORTS
            </a>
            <a
              href={GALLERY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="border-2 border-[#800000] text-[#800000] py-2 px-6 rounded-full font-bold hover:bg-[#800000] hover:text-white transition"
            >
              GALLERY
            </a>
          </div>
        </div>

        {/* Education Category */}
        <ProjectCategory
          categoryName="Education"
          projects={projectsData.education}
        />

        {/* Healthcare Category */}
        <ProjectCategory
          categoryName="Healthcare"
          projects={projectsData.healthcare}
        />

        {/* Others Category */}
        <ProjectCategory
          categoryName="Others"
          projects={projectsData.others}
        />
      </div>
    </div>
  );
}

const ProjectCategory = ({ categoryName, projects }) => {
  return (
    <section className="mb-16">
      <h2 className="text-black text-4xl font-bold mb-8 pb-3 border-b-4 border-[#800000]">
        {categoryName}
      </h2>
      <div className="space-y-12">
        {projects.map((project, index) => (
          <ProjectItem
            key={index}
            year={project.year}
            title={project.title}
            description={project.description}
            imagePath={project.imagePath || placeholderImage}
            imageOrientation={project.imageOrientation}
            imageFirst={index % 2 === 0}
            isEnded={project.isEnded}
          />
        ))}
      </div>
    </section>
  );
};

const ProjectItem = ({ year, title, description, imagePath, imageOrientation, imageFirst, isEnded }) => {
  // Adjust image container size and object-fit based on orientation
  const getImageClasses = () => {
    const baseClasses = "rounded-lg border-2 border-gray-200 shadow-md w-full";

    if (imageOrientation === "portrait") {
      return `${baseClasses} h-80 object-cover object-[center_30%]`;
    } else if (imageOrientation === "square") {
      return `${baseClasses} h-64 object-contain bg-gray-50`;
    } else {
      // landscape
      return `${baseClasses} h-64 object-cover`;
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300">
      <div className="flex flex-col lg:flex-row items-start gap-8 p-6">
        {imageFirst && (
          <div className="lg:w-1/3 flex-shrink-0">
            <img
              src={imagePath}
              alt={title}
              className={getImageClasses()}
            />
          </div>
        )}

        <div className="lg:w-2/3 space-y-4">
          <div className="flex items-baseline gap-3">
            <span className="bg-[#800000] text-white px-3 py-1 rounded-full text-sm font-bold">
              {year}
            </span>
            <h3 className="text-black text-2xl font-bold">{title}</h3>
          </div>
          <p className="text-black text-base leading-relaxed">{description}</p>
          {!isEnded && (
            <Link to="/donate">
              <button className="bg-[#800000] text-white py-2 px-6 rounded-full font-bold hover:bg-[#9b0000] transition">
                CONTRIBUTE
              </button>
            </Link>
          )}
        </div>

        {!imageFirst && (
          <div className="lg:w-1/3 flex-shrink-0">
            <img
              src={imagePath}
              alt={title}
              className={getImageClasses()}
            />
          </div>
        )}
      </div>
    </div>
  );
};
